<script setup lang="ts">
import { computed, watch } from 'vue';
import { useRoute } from 'vue-router';

import { useNavigation } from '@app/composables/useNavigation';
import { useAuthStore } from '@app/stores/auth';
import { useBoolean } from '@shared/composables/useBoolean';
import type { ThemeContext } from '@shared/composables/useTheme';

const props = defineProps<{
  theme: ThemeContext;
}>();

const auth = useAuthStore();
const route = useRoute();

const {
  navLinks,
  isPublicRoute,
  layoutVariant,
  showNavigation,
  layoutClasses,
  isNavLinkActive,
  showScannerShortcut,
  showAttendanceEndShiftShortcut,
  navigationLocked
} = useNavigation(auth, props.theme, route);

const { value: isMobileMenuOpen, toggle: toggleMobileMenu, setFalse: closeMobileMenu } = useBoolean(false);
const showMobileNavigation = computed(
  () => navLinks.value.length > 0 && isMobileMenuOpen.value && !isPublicRoute.value
);

watch(
  () => route.fullPath,
  () => {
    closeMobileMenu();
  }
);
</script>

<template>
  <slot
    :nav-links="navLinks"
    :is-nav-link-active="isNavLinkActive"
    :show-navigation="showNavigation"
    :show-mobile-navigation="showMobileNavigation"
    :is-public-route="isPublicRoute"
    :layout-classes="layoutClasses"
    :layout-variant="layoutVariant"
    :show-scanner-shortcut="showScannerShortcut"
    :show-attendance-end-shift-shortcut="showAttendanceEndShiftShortcut"
    :navigation-locked="navigationLocked"
    :is-mobile-menu-open="isMobileMenuOpen"
    :toggle-mobile-menu="toggleMobileMenu"
    :close-mobile-menu="closeMobileMenu"
  />
</template>
